import { render, staticRenderFns } from "./pack_layout.vue?vue&type=template&id=36521a66&"
import script from "./pack_layout.vue?vue&type=script&lang=js&"
export * from "./pack_layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports